module.exports = __webpack_public_path__ + "static/media/ugolok.ce663102.jpg";